import { Locale } from "@snapchat/web-i18n";
export async function loadMessages(locale) {
    // eslint-disable-next-line sonarjs/max-switch-cases
    switch (locale) {
        case Locale.ar:
        case Locale.arAR:
            return (await import("../lang/ar.json")).default;
        case Locale.bnBD:
            return (await import("../lang/bn-BD.json")).default;
        case Locale.bnIN:
            return (await import("../lang/bn-IN.json")).default;
        case Locale.daDK:
            return (await import("../lang/da-DK.json")).default;
        case Locale.deDE:
            return (await import("../lang/de-DE.json")).default;
        case Locale.enGB:
            return (await import("../lang/en-GB.json")).default;
        case Locale.elGR:
            return (await import("../lang/el-GR.json")).default;
        case Locale.es:
        case Locale.esES:
            return (await import("../lang/es.json")).default;
        case Locale.esAR:
            return (await import("../lang/es-AR.json")).default;
        case Locale.esMX:
            return (await import("../lang/es-MX.json")).default;
        case Locale.fiFI:
            return (await import("../lang/fi-FI.json")).default;
        case Locale.filPH:
            return (await import("../lang/fil-PH.json")).default;
        case Locale.frFR:
            return (await import("../lang/fr-FR.json")).default;
        case Locale.guIN:
            return (await import("../lang/gu-IN.json")).default;
        case Locale.hiIN:
            return (await import("../lang/hi-IN.json")).default;
        case Locale.idID:
            return (await import("../lang/id-ID.json")).default;
        case Locale.itIT:
            return (await import("../lang/it-IT.json")).default;
        case Locale.jaJP:
            return (await import("../lang/ja-JP.json")).default;
        case Locale.knIN:
            return (await import("../lang/kn-IN.json")).default;
        case Locale.koKR:
            return (await import("../lang/ko-KR.json")).default;
        case Locale.mlIN:
            return (await import("../lang/ml-IN.json")).default;
        case Locale.mrIN:
            return (await import("../lang/mr-IN.json")).default;
        case Locale.msMY:
            return (await import("../lang/ms-MY.json")).default;
        case Locale.nbNO:
            return (await import("../lang/nb-NO.json")).default;
        case Locale.nlNL:
            return (await import("../lang/nl-NL.json")).default;
        case Locale.pa:
            return (await import("../lang/pa.json")).default;
        case Locale.plPL:
            return (await import("../lang/pl-PL.json")).default;
        case Locale.ptBR:
            return (await import("../lang/pt-BR.json")).default;
        case Locale.ptPT:
            return (await import("../lang/pt-PT.json")).default;
        case Locale.roRO:
            return (await import("../lang/ro-RO.json")).default;
        case Locale.ruRU:
            return (await import("../lang/ru-RU.json")).default;
        case Locale.svSE:
            return (await import("../lang/sv-SE.json")).default;
        case Locale.taIN:
            return (await import("../lang/ta-IN.json")).default;
        case Locale.teIN:
            return (await import("../lang/te-IN.json")).default;
        case Locale.thTH:
            return (await import("../lang/th-TH.json")).default;
        case Locale.trTR:
            return (await import("../lang/tr-TR.json")).default;
        case Locale.urPK:
            return (await import("../lang/ur-PK.json")).default;
        case Locale.viVN:
            return (await import("../lang/vi-VN.json")).default;
        case Locale.zhHans:
            return (await import("../lang/zh-Hans.json")).default;
        case Locale.zhHant:
            return (await import("../lang/zh-Hant.json")).default;
        case Locale.enPLOC:
        case Locale.enUS:
        default:
            return (await import("../lang/en-US.json")).default;
    }
}
